import { GoPerson, GoSearch, GoStar } from "react-icons/go";
import { IoCartOutline } from 'react-icons/io5'
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Providers/AuthProvider";
import { useLocation } from 'react-router-dom'
import { useCart } from "../../../Providers/CartProvider";

import '../Styles/MobileBarsStyles.css'

const NavBarMobile = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { authState } = useAuth()
    const { cartItems } = useCart()

    const isUserLogIn = authState && authState.user ? true : false
    const isUserHasSelectedContractor = isUserLogIn && authState.custId ? true : false

    const handleNavigate = (url) => {
        if (url === '/MyAccount' && !isUserLogIn) {
            navigate('/login')
            return
        }
        else if (url === '/SavedBaskets' && !isUserLogIn) {
            navigate('/login')
            return
        }
        else if (url === '/Cart' && (!isUserLogIn || !isUserHasSelectedContractor)) {
            if (!isUserLogIn) {
                navigate('/login')
            }
            else {
                navigate('/Contractors')
            }
            return
        }
        navigate(url)
    }

    const logOutUserStyle = isUserLogIn ? '' : 'nav-bar-mobile-disable'
    const cartStyle = isUserHasSelectedContractor ? '' : 'nav-bar-mobile-disable'

    if (location.pathname.toLocaleLowerCase().includes("/cart")) {
        return null
    }
    return (<div className='container-fluid nav-bar-mobile pb-1 pt-2 fixed-bottom'>
        <div className='d-flex flex-column align-items-center  element-pointer' onClick={() => handleNavigate('/shop')}>
            <GoSearch size={25} color='var(--primary)' />
            <span>Produkty</span>
        </div>
        <div className='d-flex flex-column align-items-center  element-pointer' onClick={() => (!authState.user?.isOperator || (authState.user?.isOperator && authState.selectedCustomer !== null)) ? handleNavigate('/MyAccount') : handleNavigate('/Contractors')}>
            <GoPerson size={25} color='var(--primary)' />
            <span>Moje konto</span>
        </div>
        <div className={`${logOutUserStyle} d-flex flex-column align-items-center element-pointer`} onClick={() => handleNavigate('/SavedBaskets')}>
            <GoStar size={25} color={isUserLogIn ? 'var(--primary)' : 'var(--disabled)'} />
            <span>Ulubione</span>
        </div>
        <div className={`${cartStyle} d-flex flex-column align-items-center position-relative element-pointer`} onClick={() => handleNavigate('/Cart')}>
            <IoCartOutline size={25} color={isUserHasSelectedContractor ? 'var(--primary)' : 'var(--disabled)'} />
            <span>Koszyk</span>
            {(cartItems?.basketItems?.length > 0) && <div className={`mobile-cart-items-count-circle`}>
                {cartItems.basketItems.length}
            </div>}
        </div>
    </div>)
}

export default NavBarMobile